import { render, staticRenderFns } from "./birthdayModal.vue?vue&type=template&id=46fd961e&scoped=true"
import script from "./birthdayModal.vue?vue&type=script&lang=js"
export * from "./birthdayModal.vue?vue&type=script&lang=js"
import style0 from "./birthdayModal.vue?vue&type=style&index=0&id=46fd961e&prod&lang=scss"
import style1 from "./birthdayModal.vue?vue&type=style&index=1&id=46fd961e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fd961e",
  null
  
)

export default component.exports